export default "__VITE_ASSET__a803c9c5__"